export default __webpack_public_path__ + "static/media/calypso-mango-bbq-chilli-lime-with-prawns.3348a26b.png";